var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show-root"}},[_c('router-view'),_vm._v(" "),(!_vm.HIDDEN_DETAILS)?_c('footer-nav'):_vm._e(),_vm._v(" "),(_vm.COUPONDIALOGDATA && !_vm.isglobalLimitTimeg)?_c('globalLimitTimeg'):_vm._e(),_vm._v(" "),_c('couponLogo',{attrs:{"inDetailGo":true,"showProps":_vm._setshowProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/index.vue?vue&type=template&id=5bcd1fa2&
// module id = null
// module chunks = 